import type { FaireProductEntity } from "../../entity_types/product";

export const p_zm749t93sc: FaireProductEntity = {
  token: "p_zm749t93sc",
  type: "product",
  name: "Handblown Mexican Highball Glasses - Tamarind",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/0e9da54b11a2c908fdf4ae322186049532fdaa063e3a93ddf9ff58f1903b25ee.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8420eca7fe8020a01440414c835f5c3afd8a8ca90a8de3ae9e700bd107324030.jpeg",
    "https://cdn.faire.com/fastly/1614079d87f0f7e9d9acd08e240d922295cc1e3a641ec92f2b55784efefaf062.jpeg",
    "https://cdn.faire.com/fastly/77224e77a0f35cc7af29befcca1dcf591f382584619dcad1d0dc186e2f3c16e1.jpeg",
    "https://cdn.faire.com/fastly/5d373ce31d074ea5dcda7f35a57f9b8d79e2b9ea6c7e1603a9831adfc3ad46cf.jpeg",
    "https://cdn.faire.com/fastly/b6c15a39db517c69102890718c2c050b8ec19c97ae43207a20f5406aeac850ee.jpeg",
    "https://cdn.faire.com/fastly/99b59aa6d3577407620a827344a454f6ec4905ad9c7cb011c5d3c59432943cad.jpeg",
    "https://cdn.faire.com/fastly/5632faad9392ff8785a7db3919158ddbb9d15fbee48a5690eb286ec41408ad3b.jpeg",
  ],
  priceDollars: 10,
  description:
    "**Packaged in sets of 4 as shown; 16 single glasses in a master (4 boxes of 4 glasses)** Price shown is per glass.\n\nIntroducing our Handblown Mexican Glasses in a rich Tamarind color - the perfect match for simple, understated, and no-fuss drinks. Sustainably handcrafted by our talented glassblowing artisans in Jalisco, Mexico, each glass is meticulously shaped while molten hot, preserving its distinctive character. Available in sets of 4 for both short and highball sizes, because great drinks are meant to be enjoyed together. Elevate your drinking experience with these exquisite handblown glasses. Cheers to sustainability and craftsmanship!\n\nBe sure to check out our entire Tamarind Glassware Collection, including Short DOF Glasses, Shooter Glasses, Margarita Glasses, and matching Pitcher!\n\nCare: Dishwasher safe - Susceptible to breakage with extreme temperature changes. \n\nCapacity:\n500ml / 16 oz\n\nDimensions:\nEach Glass - 6.25'' tall x 2.5'' diameter\n",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:54:12.173Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
